import React, { PureComponent } from 'react';
import lodash from 'lodash';
import moment from 'moment';
import queryString from 'query-string';
import classNames from 'classnames';

import './styles.scss';
import Table from '../../../../components/table';
import { connect } from 'react-redux';
import { getItemDashboard, converDataDashboard, ACTIONS as actDashboard, getDropdownDashboard, getTextScore, getPitcherName } from './../../../../actions/dashboard';
import Loading from '../../../../components/loading';
import { getItemForMonths, ACTIONS as actMonth } from '../../../../actions/dashboard-team';
import {
	getDateOfMonth
} from '../../../../common/services/timesServices';

import {
	getNoticesLatest,
	ACTIONS_NOTIFICATION
} from './../../../../actions/notification';

class DashboardTeam extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			monthCurrent: 1,
			yearCurrent: new Date().getFullYear(),
			league1Item: [],
			league2Item: [],
			league3Item: [],
			itemMonth: [],
			itemDropDown: [],
			// showLoading: false,
			teamId: '',
			teamName: '',
		};
		this.onRedirect = this.onRedirect.bind(this);
		this.onGoToGame = this.onGoToGame.bind(this);
	}

	componentWillMount = () => {
		this.props.getDropdownDashboard();
		this.props.getNoticesLatest();
		this.handleDate();
	}

	componentDidMount() {
		this.setState({ showLoading: true });
		this.props.getItemDashboard();
		const parsed = queryString.parse(this.props.location.search);
		this.setState({ teamId: parsed.id })
	}

	handleDate = (text) => {
		let month;
		let year;
		switch (text) {
			case 'backmonth':
				if (this.state.monthCurrent - 1 > 0) {
					month = this.state.monthCurrent - 1;
					year = this.state.yearCurrent
				} else {
					month = 12;
					year = this.state.yearCurrent - 1
				}
				break
			case 'nextmonth':
				if (this.state.monthCurrent + 1 <= 12) {
					month = this.state.monthCurrent + 1;
					year = this.state.yearCurrent
				} else {
					month = 1;
					year = this.state.yearCurrent + 1
				}
				break
			default:
				month = (new Date().getMonth()) + 1;
				year = new Date().getFullYear()
				break;
		};
		this.setState({ showLoading: true, monthCurrent: month, yearCurrent: year, itemMonth: getDateOfMonth(month, year) }, () => {
			const parsed = queryString.parse(this.props.location.search);
			this.props.getItemForMonths(parsed.id, this.state.monthCurrent)
		});
	};


	UNSAFE_componentWillReceiveProps(nextP) {
		if (nextP) {
			if (nextP.location.search !== this.props.location.search){
				const parsed = queryString.parse(nextP.location.search);
				this.props.getItemForMonths(parsed.id, this.state.monthCurrent)
			}
			if ((nextP.statusDashboard === actDashboard.GET_ITEM_DASHBOARDS_SUCCESS && nextP.responseDashboard)
				|| (nextP.status === actMonth.GET_ITEM_MONTH_SUCCESS && nextP.response)) {
				if (nextP.responseDashboard) {
					const items = nextP.responseDashboard;

					this.setState({
						league1Item: converDataDashboard(items[0].data),
						league2Item: converDataDashboard(items[1].data),
						league3Item: converDataDashboard(items[2].data),
						showLoading: false
					});
				} if (nextP.response) {
					let data = nextP.response[0].data;
					const itemMonths = this.state.itemMonth;
					itemMonths.forEach((o) => {
						let o1 = data.find((o2) => moment(o2.teamNameResultDate, "YYYY-M-D").unix() === moment(`${o.year}-${o.month}-${o.day}`, "YYYY-M-D").unix())
						if (o1) {
							o.title = o1.team_name_s;
							o.content = getPitcherName(o1);
							o.id = o1.id;
							o.result = o1.result ? getTextScore(o1.result) : '';
							o.teamNameResultDate = o1.teamNameResultDate;
							o.isLink = o.result ? 1 : 0;
						}
					})
					this.setState({
						itemMonth: itemMonths,
						showLoading: false,
					});
				}

			}

			if (nextP.statusDashboard === actDashboard.GET_DROPDOWN_DASHBOARD_SUCCESS && nextP.dataDropdown) {

				const itemTeamDrop = [{
					id: null,
					teamName: ""
				},
				{
					id: -1,
					teamName: "全球団"
				}]
				const mergeDataDropdown = nextP.dataDropdown['central_league'].concat(nextP.dataDropdown['pacific_league'])
				mergeDataDropdown.forEach(function (o) {
					itemTeamDrop.push({
						id: o.id,
						teamName: o.team_name_s
					})
				})
				this.setState({
					itemDropDown: itemTeamDrop
				})
			}

			if (nextP.statusNotice == ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_SUCCESS) {
				let notice = nextP.responseNotice;
				if (notice && notice.content) {
					this.setState({
						textNotification: notice.content.lenght > 50 ? notice.content.slice(0, 50) : notice.content
					})
				} else {
					this.setState({
						textNotification: ""
					})
				}

			}
			const parsed = queryString.parse(window.location.search);
			let team = this.state.itemDropDown.find((t) => {
				return t.id == parsed.id;
			})
			if (team) {
				this.setState({ teamName: team.teamName, teamId: parsed.id })
			}


		} else {
			this.setState({ showLoading: false });
		}
	}

	toDashboard = (id) => {
		if (id >= 0) {
			const { history } = this.props;
			history.push({
				pathname: '/dashboard-team',
				search: `?id=${id}`
			});
		} else {
			this.setState({
				teamId: id
			})
			const { history } = this.props;
			history.push({
				pathname: '/dashboard',
				// search: `?id=${id}`
			});
		}
	};

	onRedirect(value) {
		this.props.history.push('/team-report/' + value.team_id);
	}

	onGoToGame(value) {
		const date = moment(value.teamNameResultDate, 'YYYY/MM/DD').format('YYYY-MM-DD');
		this.props.history.push(`/game/${value.id}/${this.state.teamId}/${date}`, {
			finish: value.isLink
		});
	}

	onGoToNotice() {
		this.props.history.push('/news');
	}

	render() {
		return (
			<>
				<div className="wrap-dashboard-team">
					<h1 className="title-dashboard">ダッシュボード
						<span>
                        <i className="fa fa-question-circle"></i>
                        <div className='tooltips-dash'><p>直近の試合日程とチーム勝敗表が表示できます。</p></div>
                    </span>
					</h1>
					{this.state.textNotification ? <div className="notice " onClick={() => this.onGoToNotice()}>
						<img alt="notice" className="img-notice" src="/img/ic_notice.svg" />
						<p className="text-white">{this.state.textNotification}</p>
					</div> : null}
					<div className="body-dashboard">
						<div className="head--tables  justify-content-between">
							<div className="head--tables-left  align-items-center">
								<span>{this.state.teamName} {this.state.monthCurrent}月のスケジュール</span>
								<button onClick={() => this.handleDate("backmonth")} type="button">前月</button>
								<button onClick={() => this.handleDate()} type="button">今月</button>
								<button onClick={() => this.handleDate("nextmonth")} type="button">次月</button>
							</div>
							<div className="head--tables-right">
								<select value={this.state.teamId} className="form-control" onChange={ev => this.toDashboard(ev.target.value)}>
									{
										this.state.itemDropDown.map((item, index) => item.id!==null ? (
												<option value={item.id}
														key={index.toString()}>
													{item.teamName}
												</option>
										) : (<></>)
										)
									}
								</select>
							</div>
						</div>

						<div className="body--tables">
							<div className="table-top">
								<div className={'dashboard-team-calendar'}>
									<div className={'dashboard-team-calendar-wrapper'}>
										<div className={'header-team-calendar'}>
											<div className={'header-team-calendar-item'}>
												月
											</div>
											<div className={'header-team-calendar-item'}>
												火
											</div>
											<div className={'header-team-calendar-item'}>
												水
											</div>
											<div className={'header-team-calendar-item'}>
												木
											</div>
											<div className={'header-team-calendar-item'}>
												金
											</div>
											<div className={'header-team-calendar-item'}>
												土
											</div>
											<div className={'header-team-calendar-item'}>
												日
											</div>
										</div>
										<div className={'body-team-calendar-wrapper'}>
											{
												this.state.itemMonth.map((item, i) => {
													return <div key={i} className={'body-team-calendar-item'}>
														<div className="date-name">{item.day}</div>
														{item.title && <div onClick={() => this.onGoToGame(item)}
															className={classNames('content-calendar', item.isLink && 'calendar-item-link')}>
															{item.result} {item.title} <br />{item.content}
														</div>}
													</div>
												})
											}
										</div>
									</div>
								</div>
							</div>

							<div>
								<h2 className="title-win-lose">チーム勝敗表</h2>
								<div className="">
									<div className="col-6 p-0 wrap-win-lose" style={{ width: '100%' }}>
										<div className="wrap-table-team">
											<Table
												showPagination={false} header={this.props.leagueHeader}
												showCheckbox={false} itemOfPage={this.state.league1Item}
												titleTable={this.props.titleTable3}
												onRowClick={this.onRedirect}
											/>
										</div>
										<div className="wrap-table-team">
											<Table
												showPagination={false} header={this.props.leagueHeader}
												showCheckbox={false} itemOfPage={this.state.league2Item}
												titleTable={this.props.titleTable4}
												onRowClick={this.onRedirect}
											/>
										</div>
										<div className="col-6 p-0 ">
											<div>
												<Table
													showPagination={false} header={this.props.leagueHeader}
													showCheckbox={false} itemOfPage={this.state.league3Item}
													titleTable={this.props.titleTable5}
													onRowClick={this.onRedirect}
												/>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
				<Loading show={this.state.showLoading} />
			</>
		);
	}
}

const mapStateToProps = ({ dashboardTeam, dashboard, notification }) => {
	return {
		leagueHeader: dashboard.leagueHeader,
		responseDashboard: dashboard.responseDashboard,
		statusDashboard: dashboard.statusDashboard,
		status: dashboardTeam.status,
		response: dashboardTeam.response,
		titleTable3: dashboardTeam.titleTable3,
		titleTable4: dashboardTeam.titleTable4,
		titleTable5: dashboardTeam.titleTable5,
		dataDropdown: dashboard.dataDropdown,
		responseNotice: notification.responseNotice,
		statusNotice: notification.statusNotice
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getItemForMonths: (id, month) => {
			dispatch(getItemForMonths(id, month));
		},
		getItemDashboard: () => {
			dispatch(getItemDashboard());
		},
		getDropdownDashboard: () => {
			dispatch(getDropdownDashboard());
		},
		getNoticesLatest: () => {
			dispatch(getNoticesLatest())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(DashboardTeam);
